import { useEffect } from 'react';
/**
 * Check if the widget is ready or not. If the widget is not ready yet, wait for its "ready" event.
 * Then, if provided, call the `onWidgetReady` callback.
 *
 * @param widgetRef The React reference of the Widget.
 * @param widgetName The name of the Widget (used to listen to "{name}--ready" event).
 * @param anyWidgetFct Any function of the Widget API. Before listening to the "ready" event, we check
 * if this function exists, meaning the widget is already initialized.
 * @param onWidgetReady The callback to call when the widget is ready.
 */
export function useWidgetReady(widgetRef, widgetName, anyWidgetFct, onWidgetReady) {
    useEffect(() => {
        const widget = widgetRef.current;
        const ready = () => widget && onWidgetReady();
        if (widget) {
            if (typeof widget[anyWidgetFct] === 'function') {
                // Check if the widget is already initialized...
                onWidgetReady();
            }
            else {
                // ...otherwise wait for the "ready" event.
                widget.addEventListener(`${widgetName}--ready`, ready);
            }
        }
        return () => widget?.removeEventListener(`${widgetName}--ready`, ready);
    }, [widgetRef, widgetName, anyWidgetFct, onWidgetReady]);
}
//# sourceMappingURL=use-widget-ready.js.map